document.addEventListener('click', async function (e) {
  const button = e.target.closest('.cart-drawer-upsells__atc');
  if (!button || button.disabled) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.classList.add('loading');

  const cartDrawer = document.querySelector('cart-drawer');
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  if (cartDrawer) {
    formData.append(
      'sections',
      cartDrawer.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
  }
  config.body = formData;

  try {
    const response = await fetch(routes.cart_add_url, config);
    const responseData = await response.json();

    if (responseData.status) {
      button.classList.remove('loading');
      return;
    }

    if (cartDrawer) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-drawer-upsells',
        productVariantId: variantId,
        cartData: responseData,
      });
      cartDrawer.renderContents(responseData);
    }
  } catch (e) {
    console.error(e);
    button.classList.remove('loading');
  }
});


